export const ACTION_NOTIFICATIONS_CREATE = '@action/NOTIFICATION/CREATE'
